import BaseModelAPI from '../BaseModelAPI';

export default class ReportTracingAbilityList extends BaseModelAPI {

	static entity = 'newreport2000list'
	static entityName = 'reporttracingability';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
